import { globalActions } from '../../global-actions';

export const WPN_POPUP_STATUS = Object.freeze({
  NOTHING_IS_SHOWN: 'NOTHING_IS_SHOWN',
  SHOW_CONFIRM_MODAL: 'SHOW_CONFIRM_MODAL',
  SHOW_CONFIRM_MODAL_SUCCESS: 'SHOW_CONFIRM_MODAL_SUCCESS',
  SHOW_PREFERENCES_POPUP: 'SHOW_PREFERENCES_POPUP',
  SHOW_PREFERENCES_UNSUBSCRIBE_CONFIRM: 'SHOW_PREFERENCES_UNSUBSCRIBE_CONFIRM',
  SHOW_PREFERENCES_UNSUB_SUCCESS: 'SHOW_PREFERENCES_UNSUB_SUCCESS',
});

export const getActionTypes = (actionPrefix) => ({
  SET_STATUS: `${actionPrefix}_SET_STATUS`,
  SET_SELECTED_OPTIONS: `${actionPrefix}_SET_SELECTED_OPTIONS`,
  SET_SDK: `${actionPrefix}_SET_SDK`,
  SET_IS_LOADING: `${actionPrefix}_SET_IS_LOADING`,
});

export const getActions = (actionPrefix) => ({
  setPopupStatus: (popupStatus) => {
    globalActions.next({
      type: getActionTypes(actionPrefix).SET_STATUS,
      payload: { popupStatus },
    });
  },
  setSelectedOptions: (selectBoxName, selectedOptions) => {
    globalActions.next({
      type: getActionTypes(actionPrefix).SET_SELECTED_OPTIONS,
      payload: { selectBoxName, selectedOptions },
    });
  },
  setSdk: (sdk) => {
    globalActions.next({
      type: getActionTypes(actionPrefix).SET_SDK,
      payload: { sdk },
    });
  },
  setIsLoading: (isLoading) => {
    globalActions.next({
      type: getActionTypes(actionPrefix).SET_IS_LOADING,
      payload: { isLoading },
    });
  },
});
